import { createSettingDefaultAction } from "../services/ServiceHelper";
import {
  updateUserAndSubuser,
  createSubUser,
  deleteSubUser,
  graduateUser,
  deleteUser,
} from "../services/UserService";
import { changePassword } from "../services/LoginService";
import { createActionThunk } from "redux-thunk-actions";
import {
  getEnded,
  PROFILE_DEFAULT,
  PROFILE_GET_USER_AND_SUBUSERS,
  PROFILE_EDIT_SELECTED,
  PROFILE_UPDATE_SUBMIT,
  SUB_USER_CREATE_SUBMIT,
  SUB_USER_DELETE_SUBMIT,
  CHANGE_PASSWORD_SUBMIT,
  ON_CHANGE_PROFILE_FORM,
  PROFILE_LIST_RESET,
  PROFILE_OPTION_SELECTED,
  PROFILE_LANGUAGE_SELECTED,
  SUB_USER_GRADUATE,
  USER_DELETE_SUBMIT,
  CLEAR_PROMPT,
} from "./constant";
import { reset } from "redux-form";
import { getUser } from "../services/UserService";

const setDefaultState = createSettingDefaultAction(PROFILE_DEFAULT);
const getUserWithMainUserAndSubUsers = createActionThunk(
  PROFILE_GET_USER_AND_SUBUSERS,
  (id) => getUser(id)
);
const editUserItem = (index, selectedIndex, item) => {
  return (dispatch) => {
    dispatch({
      type: PROFILE_EDIT_SELECTED,
      index: index,
    });
    dispatch(reset("formSubUserCreate"));
  };
};
const resetPage = () => {
  return (dispatch) => {
    dispatch({
      type: PROFILE_LIST_RESET,
    });
  };
};
const onChangeProfile = (e) => {
  return async (dispatch) => {
    dispatch({
      type: ON_CHANGE_PROFILE_FORM,
      event: e,
    });
  };
};
const updateProfile = createActionThunk(
  PROFILE_UPDATE_SUBMIT,
  (user, MainUser, userId) => updateUserAndSubuser(MainUser, user)
);
const subUserCreateSubmit = createActionThunk(
  SUB_USER_CREATE_SUBMIT,
  (userId, subUser) => {
    // clone and normalize before sending
    const payload = { ...subUser };
    if (Array.isArray(payload.allergen)) {
      payload.allergen = payload.allergen.map(a => (a && a._id) ? a._id : a);
    }
    // if group !== "1100", backend expects ethnicity = [] (service already enforces)
    return createSubUser(userId, payload);
  }
);
const deleteUserSubmit = createActionThunk(
  USER_DELETE_SUBMIT,
  (userId, password) => deleteUser(userId, password)
);
const subUserDeleteSubmit = createActionThunk(
  SUB_USER_DELETE_SUBMIT,
  (userId, subUserId, password) => deleteSubUser(userId, subUserId, password)
);
const changePasswordSubmit = createActionThunk(
  CHANGE_PASSWORD_SUBMIT,
  (passwords) => changePassword(passwords)
);
const optionSelected = (data, type) => {
  return async (dispatch) => {
    dispatch({
      type: PROFILE_OPTION_SELECTED,
      item: data,
      inputType: type,
    });
    dispatch({
      type: getEnded(PROFILE_OPTION_SELECTED),
    });
  };
};

const clearPrompt = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_PROMPT,
    });
  };
};

const languageSelected = (lang) => {
  return async (dispatch) => {
    dispatch({
      type: PROFILE_LANGUAGE_SELECTED,
      language: lang,
    });
  };
};

const graduateUserSubmit = createActionThunk(
  SUB_USER_GRADUATE,
  (mainUser, email, password, userID) =>
    graduateUser(mainUser, email, password, userID)
);
export default {
  setDefaultState,
  graduateUserSubmit,
  getUserWithMainUserAndSubUsers,
  updateProfile,
  editUserItem,
  subUserCreateSubmit,
  subUserDeleteSubmit,
  deleteUserSubmit,
  changePasswordSubmit,
  resetPage,
  onChangeProfile,
  optionSelected,
  languageSelected,
  clearPrompt,
};



// WEBPACK FOOTER //
// ./src/actions/profileActions.js